<template>
    <vue-ueditor-wrap v-model="description"
                      :config="myConfig" ref="ueditor"></vue-ueditor-wrap>
</template>

<script>
    import VueUeditorWrap from 'vue-ueditor-wrap';
    export default {
        name: "editor",
        components:{VueUeditorWrap},
        data(){
            return{
                description:"",
                myConfig: {
                    autoHeightEnabled: false,// 编辑器不自动被内容撑高,默认true
                    initialFrameHeight: "800",//初始化编辑器高度,默认320
                    initialFrameWidth: '100%',
                    //initialFrameWidth: '350',  //初始化编辑器宽度,默认1000
                    // UEditor 资源文件的存放路径，如果你使用的是 vue-cli 生成的项目，通常不需要设置该选项，vue-ueditor-wrap 会自动处理常见的情况，如果需要特殊配置，参考下方的常见问题2
                    UEDITOR_HOME_URL: '/UE/',
                    initialContent: '请输入内容',
                    autoClearinitialContent: true, //是否自动清除编辑器初始内容，注意：如果focus属性设置为true,这个也为真，那么编辑器一上来就会触发导致初始化的内容看不到了
                    // 工具栏是否可以浮动
                    autoFloatEnabled: false,
                    serverUrl: "https://wx.api.gymthy.com/ueditor/ueditorConfig"
                    //serverUrl: "http://127.0.0.1:66/ueditor/ueditorConfig"
                    //serverUrl: "https://wx.api.gymthy.com/ueditor/ueditorConfig"
                },
            }
        }
    }
</script>

<style scoped>

</style>
